import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ApiMemberType, MemberType, parseSimpleMarkdown } from '../helpers/ApiHelper';
import { getCompleteLocale } from '../helpers/LangHelper';

export default function TeamDetails() {
  const api = 'https://eterpaz.rdox.ch';

  const { t, i18n } = useTranslation('', { keyPrefix: 'Team' });

  const [members, setMembers] = useState<MemberType[]>();
  const [isMembersLoading, setMembersLoading] = useState<boolean>(false);

  const [selectedMember, setSelectedMember] = useState<MemberType>();

  useEffect(() => {
    setMembersLoading(true);

    try {
      fetch(
        `${api}/items/TeamMembers?filter[status][_eq]=published&sort=sort&fields=*,translations.*,translations.languages_code`
      )
        .then((res) => res.json())

        .then((json) => {
          setMembers(
            json.data.map((member: ApiMemberType) => ({
              ...member,
              introText: member.translations.find(
                (trans) => trans.languages_code === getCompleteLocale(i18n.resolvedLanguage)
              )?.introText,
              description: member.translations.find(
                (trans) => trans.languages_code === getCompleteLocale(i18n.resolvedLanguage)
              )?.description,
              // map description according to correct languages
              photoUrl: `${api}/assets/${member.photo}?width=200`,
            }))
          );
        });
    } catch (err) {
      // eslint-disable-next-line no-console
      console.warn(err);
    } finally {
      setMembersLoading(false);
    }
  }, [i18n.resolvedLanguage]);

  return (
    <div id="TeamDetails" className="container">
      <div className="row members">
        {isMembersLoading && <i>Chargement en cours...</i>}
        {members &&
          members.map((member) => (
            <div className="teamMember" key={member.id}>
              <div className="innerShadow" style={{ backgroundImage: `url(${member.photoUrl})` }} />

              <h3>{member.name}</h3>
              <p>{member.introText}</p>
              {member.description ? (
                <label
                  aria-label={member.name}
                  htmlFor={member.id}
                  className={`d-none d-md-flex ${member === selectedMember ? 'checked' : ''}`}
                >
                  <input
                    type="radio"
                    name="teamMember"
                    id={member.id}
                    value={member.id}
                    checked={selectedMember === member}
                    onChange={() => setSelectedMember(member)}
                  />
                  <i className="fa-solid fa-plus" />
                </label>
              ) : (
                ''
              )}
            </div>
          ))}
      </div>
      <h4>{t('discover', { member: selectedMember?.name || t('ourTeam') })}</h4>
      <div className="btnLine d-flex d-md-none">
        {members &&
          members.map((member) => (
            <label
              key={`input-${member.id}`}
              htmlFor={member.id}
              className={member === selectedMember ? 'checked' : ''}
            >
              <input
                type="radio"
                name="member"
                id={member.id}
                value={member.id}
                checked={selectedMember === member}
                onChange={() => setSelectedMember(member)}
              />
              {member.name}
            </label>
          ))}
      </div>
      <div className="desc">
        {members &&
          members.map((member) => (
            <p
              key={`desc-${member.id}`}
              className={`${member === selectedMember ? '' : 'hide-away'}`}
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: parseSimpleMarkdown(member.description) }}
            />
          ))}
      </div>
    </div>
  );
}
